// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDYn_ryu8fzp0VN4c1tnrY4RKeI-H0imfc",
  authDomain: "foodfortxx.firebaseapp.com",
  projectId: "foodfortxx",
  storageBucket: "foodfortxx.appspot.com",
  messagingSenderId: "130802805248",
  appId: "1:130802805248:web:12aed6ceef3a6b2e1086e5",
  measurementId: "G-5X1NV5BG46"
};

// Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);











// const firebaseConfig = {
//     apiKey: "AIzaSyBi_vRwQBQME9sk8vBifWX4nQK9s5mZrkk",
//     authDomain: "red-onion-9ce35.firebaseapp.com",
//     projectId: "red-onion-9ce35",
//     storageBucket: "red-onion-9ce35.appspot.com",
//     messagingSenderId: "981660706365",
//     appId: "1:981660706365:web:074f0ac6191958c905ac54"
// };

// export default firebaseConfig



// Import the functions you need from the SDKs you need
//import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// const firebaseConfig = {
//     apiKey: "AIzaSyD4JYN9L8lWhKg6hM72ZlLRF8BveLgkGTM",
//     authDomain: "redonionsx.firebaseapp.com",
//     projectId: "redonionsx",
//     storageBucket: "redonionsx.appspot.com",
//     messagingSenderId: "487130478353",
//     appId: "1:487130478353:web:1afbcbfb3903fea8203eb0"
//   };

  export default firebaseConfig


